import { render, staticRenderFns } from "./CubeShadow.vue?vue&type=template&id=72c52292&scoped=true&"
import script from "./CubeShadow.vue?vue&type=script&lang=js&"
export * from "./CubeShadow.vue?vue&type=script&lang=js&"
import style0 from "./CubeShadow.vue?vue&type=style&index=0&id=72c52292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c52292",
  null
  
)

export default component.exports